import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./AppShell";
import { AuthRoute, DashboardRoute, HomeRoute, ProtectedRoute } from "./RouteShells";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false }, mutations: { retry: 0 } },
});

export function App() {
  return <QueryClientProvider client={queryClient}><BrowserRouter><Routes><Route element={<AppShell />}>
    <Route path="/" element={<HomeRoute />} />
    <Route path="/auth/*" element={<AuthRoute />} />
    <Route element={<ProtectedRoute />}>
      <Route path="/app" element={<DashboardRoute />} />
      <Route path="/app/snapshots/:snapshotId" element={<DashboardRoute />} />
      <Route path="/app/team" element={<DashboardRoute />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Route></Routes></BrowserRouter></QueryClientProvider>;
}
